import { useBranding } from '@/lib/branding/BrandingProvider';
import { GuideSection } from '@/components/guides/GuideSection';
import { GuideCallout } from '@/components/guides/GuideCallout';
import { GuideAction } from '@/components/guides/GuideAction';
import { GuideScreenshot } from '@/components/guides/GuideScreenshot';

const TOUR = [
  { href: '/', label: 'Overview', blurb: 'KPIs, company code, charts, and recent activity.' },
  { href: '/end-clients', label: 'Candidates', blurb: 'Your roster of interview subjects.' },
  {
    href: '/interviews',
    label: 'Interviews',
    blurb: 'Schedule interviews and review transcripts.',
  },
  { href: '/tests', label: 'Tests', blurb: 'Online assessments using the same NeuraX engine.' },
  { href: '/licenses', label: 'NeuraX Licenses', blurb: 'Every license your team has issued.' },
  { href: '/employees', label: 'Employees', blurb: 'Invite and manage your teammates.' },
  { href: '/billing', label: 'Billing', blurb: 'Current plan, pricing tiers, invoices, refunds.' },
  { href: '/guides', label: 'Guides', blurb: 'You are here.' },
];

export function WelcomeTourSection() {
  const brand = useBranding();
  return (
    <GuideSection
      id="welcome"
      eyebrow="Start here"
      title={`Welcome to ${brand.productName}`}
      description="A one-minute tour of the portal so you know where everything lives."
    >
      <p className="text-sm text-muted-foreground">
        {brand.productName} gives you one workspace to manage candidates, schedule interviews, and
        review what NeuraX coached them through in real time. Every page in the sidebar maps to one
        job. Here's a quick tour.
      </p>

      <GuideScreenshot
        src="/guides/dashboard-overview.png"
        alt="Overview page showing sidebar navigation, a company code card, four KPI cards (team members, candidates, active licenses, monthly quota), and a Sessions over time chart"
        caption="The Overview page — your daily glance. Company code at top, KPIs and charts below."
      />

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {TOUR.map((item) => (
          <div key={item.href} className="glass-card flex items-start justify-between gap-3 p-4">
            <div>
              <p className="text-sm font-semibold text-white">{item.label}</p>
              <p className="mt-0.5 text-xs text-muted-foreground">{item.blurb}</p>
            </div>
            <GuideAction href={item.href}>Open</GuideAction>
          </div>
        ))}
      </div>

      <GuideCallout variant="tip" title="The typical workflow">
        <p>
          Add a <strong>candidate</strong> → <strong>schedule</strong> an interview (licenses are
          issued automatically in the wizard) → candidate runs NeuraX during their interview → you
          review the <strong>transcript + coaching</strong> afterwards.
        </p>
      </GuideCallout>
    </GuideSection>
  );
}
